export function getAlert(state) {
  return state.alert;
}



// WEBPACK FOOTER //
// ./src/core/alerts/selectors.js